export default { sha: '8814575b57497949a59ff43e82b9ecaa047fa7fb', buildNumber: 'undefined' }
